const Logger = require('@ffw/logger-lib');
// Load the default routes.
const routesCore = require('../../config/core/client.routes.json');

/**
 * Get OpCo routes from the config file.
 * @return {*}
 */
function getOpCoRoutes(country = process.env.REACT_APP_COUNTRY) {
  let routesOpCo;
  try {
    // Load the routes for the specific country.
    // Depends on the app country and should be dynamic.
    /* eslint-disable-next-line import/no-dynamic-require, global-require */
    routesOpCo = require(`../../config/${country}/client.routes.json`);
  } catch (error) {
    routesOpCo = routesCore;
    Logger.error(`Missing client routes configs for: ${country}`, 'Get OpCO Routes');
  }

  return { ...routesOpCo };
}

/**
 * Get amount of available languages for the particular OpCo.
 *
 * @return {boolean}
 */
const isMultilingual = () => Object.keys(getOpCoRoutes()).length > 1;

const getLocaleByPath = (path) => {
  const routesOpCo = getOpCoRoutes();
  const routesByLanguages = Object.keys(routesOpCo).map((lang) => ({
    [lang]: Object.keys(routesOpCo[lang]).map((route) => routesOpCo[lang]?.[route]?.url),
  })).reduce((prev, cur) => ({ ...prev, ...cur }), {});

  return Object.keys(routesByLanguages)?.find((lang) => routesByLanguages[lang]?.includes(path));
};

export { isMultilingual, getLocaleByPath };
export default getOpCoRoutes;
